import React from 'react';
import noop from 'lodash/noop';
import pt from 'prop-types';

import { classNames } from 'utils';

import Popover from 'components/popover';

import './tooltip.scss';

export default class Tooltip extends React.PureComponent {
  static propTypes = {
    side: pt.oneOf(['top', 'left', 'bottom', 'right']),
    align: pt.oneOf(['start', 'center', 'end']),
    delayed: pt.bool,
    enterDuration: pt.number,
    message: pt.oneOfType([pt.string, pt.object]),
    className: pt.string,
    triggerClassName: pt.string,
    contentClassName: pt.string,
    maxTextLineWidth: pt.number,
    maxTextLineSeparator: pt.string,
    sideOffset: pt.number,
    arrow: pt.bool,
    children: pt.node.isRequired,
    openOnHover: pt.bool,
  };

  render() {
    const {
      side = 'top',
      align = 'center',
      message = '',
      openOnHover = true,
      delayed = false,
      enterDuration,
      sideOffset,
      maxTextLineWidth,
      maxTextLineSeparator,
      triggerClassName,
      contentClassName,
      className,
      arrow,
      children,
    } = this.props;

    if (!message) {
      return children;
    }

    return (
      <span className={classNames('tooltip-help', className)} role="tooltip">
        <Popover
          side={side}
          sideOffset={sideOffset}
          align={align}
          message={message}
          contentClassName={contentClassName}
          enterDuration={enterDuration ?? (delayed ? 250 : undefined)}
          maxTextLineWidth={maxTextLineWidth}
          maxTextLineSeparator={maxTextLineSeparator}
          triggerClassName={triggerClassName}
          triggerChildren={children}
          triggerOnClick={noop}
          openOnHover={openOnHover}
          arrow={arrow}
        />
      </span>
    );
  }
}
